var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white",class:[_vm.classes]},[_c('div',{staticClass:"box-backgroud-title text-primary-700 px-5 py-2 flex justify-between items-center",class:[_vm.classes]},[_c('span',{staticClass:"font-sans text-lg"},[_vm._v(_vm._s(_vm.title ? _vm.title : ''))]),_c('div',[_vm._t("actions")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }